export function slugifyNewsTitle(value?: string) {
  return (value || "news")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-{2,}/g, "-");
}

export function buildNewsSlug(title?: string, fallbackId?: string) {
  const slug = slugifyNewsTitle(title);

  if (fallbackId) {
    return `${slug || "news"}--${fallbackId}`;
  }

  return slug || "news";
}

export function buildNewsPath(title?: string, fallbackId?: string, slug?: string) {
  return `/news/${slug || buildNewsSlug(title, fallbackId)}`;
}

export function extractNewsId(value?: string) {
  if (!value) {
    return "";
  }

  const separatorIndex = value.lastIndexOf("--");
  if (separatorIndex === -1) {
    return value;
  }

  return value.slice(separatorIndex + 2);
}
